import { useCallback, useState, useEffect } from 'react';
import TextField from '@mui/material/TextField';
import { popupClasses } from '../../utility';
import EntityDetailPopup from '../../utility/EntityDetailPopup';
import { MenuItem } from '@mui/material';

const itemKeys = ['item_name', 'category_name', 'category_type', 'quantity_type', 'unit_name', 'strain_name', 'strain'];

export default function ItemEntryPopup(props) {
  const { handleItemSave, handleSetSelItem, selItem, currDarkThemeClass = '', unitList = [], ...otherProps } = props;

  const [values, setValues] = useState({});

  const handleSetValues = useCallback((prop, value) => setValues(state => ({ ...state, [prop]: value })), [setValues]);

  const itemEntryTextFieldProps = ({ prop, inputProps = {}, otherTextProps = {} }) => {
    const isReadOnly = prop !== 'unit_name';
    return {
      autoComplete: 'off',
      className: `${popupClasses?.strainEntry?.textField} ${currDarkThemeClass}`,
      fullWidth: true,
      inputProps: {
        readOnly: isReadOnly,
        style: isReadOnly
          ? {
              backgroundColor: '#141414',
              cursor: 'not-allowed',
            }
          : {},
      },
      label: ' ',
      onChange: isReadOnly ? undefined : ({ target: { value } }) => handleSetSelItem(prop, value),
      required: true,

      value: selItem?.[prop] ?? '',
      ...otherTextProps,
    };
  };

  const handleItemEntrySave = async () => {
    if (itemKeys.some(e => !selItem?.[e])) return;

    handleSetValues('loading', true);

    let res = { success: false };

    try {
      res = await handleItemSave(selItem);
    } catch {
    } finally {
      handleSetValues('loading', false);
    }

    if (res?.success) {
      otherProps?.onClose?.();
    }
  };

  const entityDetailProps = {
    currDarkThemeClass,
    loading: values?.loading,
    headContentText: false,
    onSaveClick: handleItemEntrySave,
    ...otherProps,
  };

  const itemNameProps = {
    otherTextProps: {
      autoFocus: true,
      label: 'Item Name',
    },
    prop: 'item_name',
  };
  const categoryNameProps = {
    InputProps: { maxLength: 100 },
    otherTextProps: {
      autoFocus: true,
      label: 'Category Name',
      type: 'text',
    },
    prop: 'category_name',
  };
  const categoryTypeProps = {
    InputProps: { maxLength: 100 },
    otherTextProps: {
      autoFocus: true,
      label: 'Category Type',
      type: 'text',
    },
    prop: 'category_type',
  };
  const QuantityTypeProps = {
    InputProps: { maxLength: 100 },
    otherTextProps: {
      autoFocus: true,
      label: 'Quantity Type',
      type: 'text',
    },
    prop: 'quantity_type',
  };
  const UnitNameProps = {
    InputProps: { maxLength: 100 },
    otherTextProps: {
      autoFocus: true,
      label: 'Unit Name',
      type: 'text',
    },
    prop: 'unit_name',
  };
  const strainNameProps = {
    InputProps: { maxLength: 100 },
    otherTextProps: {
      autoFocus: true,
      label: 'Strain Name',
      type: 'text',
    },
    prop: 'strain_name',
  };

  return (
    <EntityDetailPopup {...entityDetailProps}>
      <TextField {...itemEntryTextFieldProps(itemNameProps)} />
      <TextField {...itemEntryTextFieldProps(categoryNameProps)} />
      <TextField {...itemEntryTextFieldProps(categoryTypeProps)} />
      <TextField {...itemEntryTextFieldProps(QuantityTypeProps)} />
      {/* <TextField {...itemEntryTextFieldProps(UnitNameProps)} /> */}
      <TextField
        select
        {...itemEntryTextFieldProps({
          prop: 'unit_name',
          otherTextProps: { label: 'Unit Name' },
        })}
      >
        {unitList.filter(unit => unit.unit_type === selItem?.quantity_type).length > 0 ? (
          unitList
            .filter(unit => unit.unit_type === selItem?.quantity_type)
            .map(unit => (
              <MenuItem key={unit.id} value={unit.unit_name}>
                {unit.unit_name}
              </MenuItem>
            ))
        ) : (
          <MenuItem disabled>No units available</MenuItem>
        )}
      </TextField>
      <TextField {...itemEntryTextFieldProps(strainNameProps)} />
    </EntityDetailPopup>
  );
}
